'use client'

import { useContext, useEffect, useState } from 'react'

import { AdPage, AdShape } from '@marketplace-web/ads/ads-data'
import { ConsentGroup, useIsConsentGroupEnabled } from '@marketplace-web/shared/consent'
import { useUserAgent } from '@marketplace-web/shared/request'
import { useSystemConfiguration } from '@marketplace-web/shared/system-configuration'
import { CountryCode } from '@marketplace-web/domain/country-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

import useFetchVanPlacement from '../useFetchVanPlacement'
import VanOfferContent from './VanOfferContent'
import AdsContext from '../../../containers/AdsProvider/AdsContext'
import useShouldShowVanOffer from '../useShouldShowVanOffer'
import useIsTransactionEligibleForAd from '../useIsTransactionEligibleForAd'
import { useShouldShowRokt } from '../RoktAdvertisement'

// This is hardcoded at the moment as we don't have placement for this specific ad
const placementId = 'web_purchase_van'

const VanOfferAdvertisement = () => {
  const [isOpen, setIsOpen] = useState(true)
  const hasConsentedTargeting = useIsConsentGroupEnabled(ConsentGroup.VanAdvertising)
  const { transaction } = useConversationContext()
  const transactionId = transaction?.id
  const isDebitProcessed = transaction?.isDebitProcessed

  const userAgent = useUserAgent()
  const { getAdsPlatform } = useContext(AdsContext)
  const { userCountry: countryCode } = useSystemConfiguration()

  const { shouldShowVanOffer, setShouldShowVan } = useShouldShowVanOffer()
  const { setShouldShowRokt, hasRoktBeenShown } = useShouldShowRokt()
  const isEligibleForAd = useIsTransactionEligibleForAd(transactionId)

  const { placement, fetchVanAdPlacement } = useFetchVanPlacement({
    placementId,
    shape: AdShape.Rectangle,
    consentStatus: hasConsentedTargeting,
    page: AdPage.Messages,
    platform: getAdsPlatform(userAgent),
    countryCode: countryCode as CountryCode,
  })

  const onClose = () => setIsOpen(false)

  const shouldRunVanAd =
    shouldShowVanOffer && isDebitProcessed && !hasRoktBeenShown && isEligibleForAd

  useEffect(() => {
    if (!shouldRunVanAd) return

    fetchVanAdPlacement()
    setShouldShowVan(false)
  }, [fetchVanAdPlacement, setShouldShowVan, shouldRunVanAd])

  useEffect(() => {
    if (!shouldShowVanOffer) return

    setShouldShowRokt(false)
  }, [shouldShowVanOffer, setShouldShowRokt])

  if (!placement?.creative) return null

  return (
    <div data-testid="van-offer-content">
      <VanOfferContent
        isOpen={isOpen}
        onClose={onClose}
        config={placement}
        creative={placement.creative}
      />
    </div>
  )
}

export default VanOfferAdvertisement
